import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1561afd7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1561afd7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1561afd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1561afd7')) {
      api.createRecord('1561afd7', component.options)
    } else {
      api.reload('1561afd7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1561afd7&scoped=true", function () {
      api.rerender('1561afd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productView/index.vue"
export default component.exports